import { useEffect } from 'react';
import { useStore } from 'jotai';

import { aiGenerateDockUiAtom } from '../stores/aiGenerateDock.atoms';
import { aiGenerateDockRunAtom } from '../stores/aiGenerateDockRun.atoms';

/**
 * 빌드 화면을 벗어날 때 생성기 원자를 처음 값으로 되돌린다. 원자는 앱 전역 저장소에 있어, 실패 카드(와 그
 * retry 클로저)·열림·탭이 남은 채 다른 퀴즈 편집 화면으로 클라이언트 이동하면 새 화면에 지난 상태가 나타나고
 * 재시도는 이미 사라진 폼·세션을 가리킨다(문항 카드 AI 슬롯의 useResetQuestionCardAiSlots 와 같은 이유).
 */
export const useResetAiGenerateDock = () => {
  const store = useStore();
  useEffect(
    () => () => {
      store.set(aiGenerateDockRunAtom, { type: 'reset' });
      store.set(aiGenerateDockUiAtom, { type: 'reset' });
    },
    [store],
  );
};
